import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import {
  Button,
  Grid,
  Stack,
  Typography,
  IconButton,
  Snackbar,
  SnackbarContent,
  Menu,
  MenuItem
} from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/AssessmentOutlined";
import PlayIcon from "@mui/icons-material/PlayCircleFilled";
import MintIcon from "@mui/icons-material/AddBoxOutlined";
import MyCardsIcon from "@mui/icons-material/AppsSharp";
import MyPacksIcon from "@mui/icons-material/ViewAgendaOutlined";
import MarketIcon from "@mui/icons-material/StoreSharp";
import TwitterIcon from "@mui/icons-material/Twitter";
import TelegramIcon from "@mui/icons-material/Telegram";
import CloseIcon from "@mui/icons-material/CloseSharp";
import MenuIcon from "@mui/icons-material/MenuOutlined";
import FarmIcon from "@mui/icons-material/AccountBalanceOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import FaceIcon from "@mui/icons-material/PersonPin";
import OfferIcon from "@mui/icons-material/LocalOffer";
import ListingsIcon from "@mui/icons-material/ListOutlined";

import { NavLink } from "react-router-dom";

import ConnectWalletModal from "../wallet/ConnectWalletModal";
import {
  Network,
  getTokenPriceInDollars,
  baseTokenContractAddress,
} from "../contracts/ContractProvider";
import TransactionQueueSize from "../hooks/TransactionQueueSize";
import { useInterval } from "../hooks/useInterval";

const navItems = [
  { to: "dashboard", icon: <DashboardIcon color="default" /> },
  { to: "play", icon: <PlayIcon color="default" /> },
  // { to: "swap", icon: <SwapIcon color="default" /> },
  { to: "mint", icon: <MintIcon color="default" /> },
  /*
  { to: "farm", icon: <FarmIcon color="default" /> },
  { to: "avatars", icon: <FaceIcon color="default" /> },*/

  // MY SHIRYO

  { to: "my-collection", icon: <MyCardsIcon color="default" /> },
  { to: "my-packs", icon: <MyPacksIcon color="default" /> },

  // MARKET

  { to: "market", icon: <MarketIcon color="default" /> },
  { to: "my-offers", icon: <OfferIcon color="default" /> },
  { to: "my-listings", icon: <ListingsIcon color="default" /> },
];

const drawerWidth = 220;

const DrawerList = ({ tokenPriceDollars, mobileOpen }) => {
  return (
    <Stack justifyContent="space-between" height="100%" sx={{ border: "none" }}>
      <Toolbar>
        <Grid container justify="center" alignItems="center">
          <Grid item align="center" margin="0 auto">
            <img src="./logo.png" alt="SHIRYO" height="32" />
          </Grid>
        </Grid>
      </Toolbar>

      <List sx={{ paddingTop: "0px" }}>
        {navItems.map((navItem, index) => {
          return (
            <>
              {navItem.to === "my-collection" && (
                <Typography
                  textAlign="center"
                  variant="body2"
                  sx={{ mt: 3, mb: 1 }}
                >
                  MY SHIRYO
                </Typography>
              )}
              {navItem.to === "market" && (
                <Typography
                  textAlign="center"
                  variant="body2"
                  sx={{ mt: 3, mb: 1 }}
                >
                  MARKETPLACE
                </Typography>
              )}
              <ListItem
                key={index}
                component={NavLink}
                to={`/${navItem.to}`}
                button
                sx={{ py: { xs: 1, sm: 1 } }}
              >
                <ListItemIcon sx={{ marginRight: "-16px", marginLeft: "16px" }}>
                  {navItem.icon}
                </ListItemIcon>
                <ListItemText
                  primary={navItem.to.toUpperCase().replace("-", " ")}
                />
              </ListItem>
            </>
          );
        })}
      </List>
      <List style={{ marginTop: `auto` }}>
        <ListItem>
          <Grid container justifyContent="center">
            <Stack sx={{ width: 150 }}>
              <Grid item sx={{ textAlign: "center" }}>
                <img src="../favicon.png" alt="Shiryoinu" />
              </Grid>
              {/*
              <Grid item sx={{ textAlign: "center" }}>
                <Typography variant="subtitle1" sx={{ pt: 3 }}>
                  CURRENT PRICE
                </Typography>
                <Typography variant="subtitle2">
                  ${tokenPriceDollars}
                </Typography>
              </Grid>
            */}
              <Grid item sx={{ py: 1 }}>
                <Grid container justifyContent="space-evenly">
                  <Grid item>
                    <a
                      href="https://twitter.com/shiryo_official"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <TwitterIcon color="primary" />
                    </a>
                  </Grid>
                  <Grid item>
                    <a
                      href="https://discord.com/invite/wq6URbsa"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 71 55"
                        fill="none"
                      >
                        <g clipPath="url(#clip0)">
                          <path
                            d="M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0834 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0581 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9057 44.6363 54.2779 44.9293 54.6529 45.2082C54.7816 45.304 54.7732 45.5041 54.6333 45.5858C52.8646 46.6197 51.0259 47.4931 49.0921 48.2228C48.9662 48.2707 48.9102 48.4172 48.9718 48.5383C50.038 50.6034 51.2554 52.5699 52.5959 54.435C52.6519 54.5139 52.7526 54.5477 52.845 54.5195C58.6464 52.7249 64.529 50.0174 70.6019 45.5576C70.6551 45.5182 70.6887 45.459 70.6943 45.3942C72.1747 30.0791 68.2147 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.3451 34.1136 17.3451 30.1693C17.3451 26.225 20.1717 23.0133 23.7259 23.0133C27.308 23.0133 30.1626 26.2532 30.1066 30.1693C30.1066 34.1136 27.28 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.9371 34.1136 40.9371 30.1693C40.9371 26.225 43.7636 23.0133 47.3178 23.0133C50.9 23.0133 53.7545 26.2532 53.6986 30.1693C53.6986 34.1136 50.9 37.3253 47.3178 37.3253Z"
                            fill="#2b43c2"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect width="71" height="55" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </Grid>
                  <Grid item>
                    <a
                      href="https://t.me/Shiryo_Official"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <TelegramIcon color="primary" />
                    </a>
                  </Grid>
                  {/**
                <Grid item>
                  <DiscordIcon color="primary" />
                </Grid>
                 */}
                </Grid>
              </Grid>
            </Stack>
          </Grid>
        </ListItem>
      </List >
    </Stack >
  );
};

export default function Navigation(props) {
  const CONTRACT_POLLING_INTERVAL = 2000; // millis

  const [mobileOpen, setMobileOpen] = React.useState(false);

  const [wrongNetworkOpen, setWrongNetworkOpen] = useState(true);

  const [queueSize, setQueueSize] = React.useState(0);

  const [tokenPriceDollars, setTokenPriceDollars] = React.useState(0);


  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const fetchData = async () => {
    setQueueSize(TransactionQueueSize.size);
  };

  useInterval(() => {
    try {
      fetchData();
    } catch (error) {
      console.log(error);
    }
  }, CONTRACT_POLLING_INTERVAL);

  const fetchTokenPrice = async () => {
    let tokenInUSD = await getTokenPriceInDollars(baseTokenContractAddress);
    setTokenPriceDollars(tokenInUSD.toFixed(12));
  };

  useEffect(() => {
    //fetchTokenPrice();
    /*
    fetch("https://api.binance.com/api/v3/ticker/price?symbol=BNBUSDC")
      .then((res) => res.json())
      .then((result) => {//console.log(result.price)});
*/
  });

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar
          color="inherit"
          position="fixed"
          sx={{
            width: { sm: `calc(100% - ${drawerWidth}px)` },
            ml: { sm: `${drawerWidth}px` },
          }}
        >
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* {queueSize > 0 && (
              <Box sx={{ display: "flex" }}>
                <CircularProgress />
              </Box>
            )} */}
            {queueSize > 0 && (
              <Snackbar
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                open={true}
              //onClose={handleClose}
              >
                <SnackbarContent
                  sx={{ background: "#0E111D" }}
                  message={
                    <Grid display="flex" alignItems="center">

                      <CircularProgress size={24} />
                      <Typography sx={{ pl: 3 }} variant="subtitle2">
                        Waiting for {queueSize}{" "}
                        {queueSize > 1 ? "transactions" : "transaction"}...
                      </Typography>
                    </Grid>
                  }
                />
              </Snackbar>
            )}

            <ConnectWalletModal
              setWalletModal={props.setWalletModal}
              walletModal={props.walletModal}
            />
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            <Grid
              item
              sx={{
                position: "absolute",
                top: "12px",
                left: "45%",
                transform: "translate(-50%, 0)",
                display: { sm: "none" },
              }}
            >
              <img
                style={{ height: "32px" }}
                src="https://app.shiryo.com/logo.png"
                alt="SHIRYO"
              />
            </Grid>

            {props.account ? (
              <Grid
                item
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  marginLeft: "auto",
                  marginRight: "0",
                  cursor: "pointer",
                  textDecoration: "none",
                }}
              //component={NavLink}
              // to="/profile"
              >

                <img
                  onClick={handleClick}
                  style={{ verticalAlign: "middle", marginRight: "8px", marginLeft: "auto" }}
                  height="24"
                  src="./polygon.png"
                  alt={props.account}

                />
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  <MenuItem onClick={handleClose} component="a" href="https://app.shiryo.com/"><img

                    style={{ verticalAlign: "middle", marginRight: "8px" }}
                    height="24"
                    src="https://seeklogo.com/images/E/ethereum-logo-EC6CDBA45B-seeklogo.com.png"
                    alt={props.account}

                  />Switch to Ethereum</MenuItem>
                </Menu>

                {/* <img
                  style={{ marginRight: "8px" }}
                  height="34"
                  src="./wolf_round.png"
                  alt={props.account}
                /> */}



                <Button
                  color="primary"
                  variant="outlined"
                  sx={{
                    mr: 0,
                    ml: "auto",
                    display: { xs: "none", sm: "block" },
                  }}
                >
                  {props.account && props.account.substr(0, 6)}...
                  {props.account &&
                    props.account.substr(
                      props.account && props.account.length - 3,
                      3
                    )}
                </Button>
              </Grid>
            ) : (
              <>

                <img
                  onClick={handleClick}
                  style={{ verticalAlign: "middle", marginRight: "8px", marginLeft: "auto" }}
                  height="24"
                  src="./polygon.png"
                  alt={props.account}

                />
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    'aria-labelledby': 'basic-button',
                  }}
                >
                  <MenuItem onClick={handleClose} component="a" href="https://app.shiryo.com/"><img

                    style={{ verticalAlign: "middle", marginRight: "8px" }}
                    height="24"
                    src="https://seeklogo.com/images/E/ethereum-logo-EC6CDBA45B-seeklogo.com.png"
                    alt={props.account}

                  />Switch to Ethereum</MenuItem>
                </Menu>
                <Button
                  color="primary"
                  variant="contained"
                  // sx={{ mr: 0, ml: "auto" }}
                  onClick={() => props.setWalletModal(true)}
                >
                  Connect
                </Button>
              </>
            )}
          </Toolbar>
          {props.wrongNetwork && wrongNetworkOpen && (
            <Grid
              sx={{ background: "darkred" }}
              container
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item></Grid>
              <Grid item>
                <Typography variant="subtitle2">
                  Wrong network! Please connect to {Network}
                </Typography>
              </Grid>
              <Grid item>
                <CloseIcon
                  style={{
                    verticalAlign: "middle",
                    cursor: "pointer",
                    padding: "4px",
                  }}
                  onClick={() => setWrongNetworkOpen(false)}
                />
              </Grid>
            </Grid>
          )}
        </AppBar>

        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
            onClick: () => handleDrawerToggle(),
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
              border: "none",
            },
          }}
        >
          <DrawerList
            tokenPriceDollars={tokenPriceDollars}
            mobileOpen={mobileOpen}
          />
        </Drawer>
        <Drawer
          sx={{
            display: { xs: "none", sm: "block" },
            position: "relative",
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              border: "none",
            },
          }}
          variant="permanent"
          anchor="left"
        >
          <DrawerList tokenPriceDollars={tokenPriceDollars} />
        </Drawer>
      </Box>
    </>
  );
}
